/* eslint-disable */
/**
 * globalNav
 */

import $ from 'jquery';

// Module dependencies
import 'protons';

// Module styles
import './_global-nav-biz.scss';

// Module template
import './_global-nav-biz.twig';

export const name = 'globalNavBiz';

export const defaults = {
  dummyClass: 'js-globalNavBiz-exists',
};

/**
 * Components may need to run clean-up tasks if they are removed from DOM.
 *
 * @param {jQuery} $context - A piece of DOM
 * @param {Object} settings - Pertinent settings
 */
// eslint-disable-next-line no-unused-vars
export function disable($context, settings) { }

export function enable($context, { globalNavBiz = {} }) {
  // Find our component within the DOM
  const $globalNavBiz = $('.global-nav-biz-component', $context);
  // Bail if component does not exist
  if (!$globalNavBiz.length) {
    return;
  }
  // Merge defaults with incoming settings
  const settings = Object.assign(defaults, globalNavBiz);
  // An example of what could be done with this component
  $globalNavBiz.addClass(settings.dummyClass);

  const $openGlobalNavBizButton = $globalNavBiz.find('.global-nav-biz__toggle');
  const $globalNavBizWrapper = $globalNavBiz.find('.global-nav-biz-container');
  const $childGlobalNavBizToggle = $globalNavBiz.find('.global-nav-biz__nav-toggle');
  //Find Embedded Site Nav Toggle
  const $toggleSiteNav = $globalNavBiz.find('.this-site .global-nav-biz__nav-toggle').first();
  const $siteNavMegaToggle = $globalNavBiz.find('.mega-toggle');
  const $fullRezNavToggle = $globalNavBiz.find('.global-nav-biz__nav-toggle.drop');

  // Stick Mega menu in embedded site nav
  $('.dropdown-menu.dropdown-fullwidth').clone().appendTo("li.mega-item");
  $('li.mega-item .dropdown-fullwidth').addClass('show');
  $childGlobalNavBizToggle.on('click', () => {
    // console.log("NAV TOggle Yo");
  })

  // Toggle nav open/close
  $openGlobalNavBizButton.on('click', function () {
    const isMenuOpen = $('body').hasClass('menu-open');
    if (!isMenuOpen) {
      // Ensure the site nav is in a closed state before triggering click
      if (!$toggleSiteNav.hasClass('open')) {
        $toggleSiteNav.trigger("click");
      }
    }
    $globalNavBizWrapper.toggleClass('menu-open');
    $('body').toggleClass('menu-open');
  });

  // Close menu when clicking outside in mobile
  $(document).on('click', function (event) {
    if ($(window).width() < 1119.99) {
      const isClickInsideMenu = $(event.target).closest('.global-nav-biz-component').length > 0;
      const isClickOnMenuButton = $(event.target).closest('.global-nav-biz__toggle').length > 0;

      if (!isClickInsideMenu && !isClickOnMenuButton) {
        $('body').removeClass('menu-open'); // Remove overlay
        $globalNavBizWrapper.removeClass('menu-open'); // Close the menu
      }
    }
  });


  // Toggle nav child links open/close
  $childGlobalNavBizToggle.on('click', $childGlobalNavBizToggle, el => {
    const $plus = $(el.currentTarget);
    $plus
      .toggleClass('open')
      .siblings('ul')
      .slideToggle('fast');

    $plus.parent('li').toggleClass('section-open');
    $plus.siblings('ul').toggleClass('show');
    $plus.siblings('ul').removeAttr("display");
    el.preventDefault();
  });




}


// Swap nav postions for mobile
$(window).on('resize load pagebeforecreate', () => {
  if ($(window).width() < 1119.99) {
    $(".left-list>:first-child.global-nav-biz__primary-nav-item a").text('Fannie Mae Home');
    $(".region-global").insertAfter(".region-site");
  } else {
    $(".region-site").insertAfter(".region-global");
    $(".left-list>:first-child.global-nav-biz__primary-nav-item a").text('Home');
  }
});
// -- Handling  key board tabbing - start -- //

document.querySelectorAll('[role="menubar"]').forEach(menu => {
  const menuItems = menu.querySelectorAll('li');

  menuItems.forEach(item => {
    ['focusin', 'mouseenter'].forEach(eventType => {
      item.addEventListener(eventType, e => {
        // Remove focus from all siblings, so that multiple menu is not open in the same time
        Array.from(item.parentElement.children).forEach(sibling => {
          if (sibling !== item) {
            sibling.classList.remove('focus');
            const link = sibling.querySelector('[role="menuitem"]');
            if (link) link.setAttribute('aria-expanded', 'false');
          }
        });
        // focus the item and display submenu
        item.classList.add('focus');
        const submenuTrigger = item.querySelector('[role="menuitem"]');
        const submenu = item.querySelector('ul[role="menu"]');
        if (submenuTrigger && submenu) {
          submenuTrigger.setAttribute('aria-expanded', 'true');
        }
      });
    });

    ['focusout', 'mouseleave'].forEach(eventType => {
      item.addEventListener(eventType, e => {
        // settimeout used here to delay execution until the browser knows where focus is
        setTimeout(() => {
          if (!item.contains(document.activeElement)) {
            item.classList.remove('focus');
            const link = item.querySelector('[role="menuitem"]');
            if (link) link.setAttribute('aria-expanded', 'false');
          }
        }, 0);
      });
    });
  });
});

// Add arrow navigation and escape close
document.querySelectorAll('[role="menuitem"]').forEach(item => {
  item.addEventListener('keydown', (e) => {
    const currentItem = e.target;
    const parentMenu = currentItem.closest('[role="menu"]');
    if (!parentMenu) return;

    // item.offsetParent is used to eliminate invisible items
    const allItems = Array.from(
      parentMenu.querySelectorAll('[role="menuitem"]')
    ).filter(item => item.offsetParent !== null);

    const index = allItems.indexOf(currentItem);

    switch (e.key) {
      case 'ArrowDown':
        e.preventDefault();
        if (index < allItems.length - 1) allItems[index + 1].focus();
        break;
      case 'ArrowUp':
        e.preventDefault();
        if (index > 0) allItems[index - 1].focus();
        break;
      case 'Escape':
        e.preventDefault();
        let parentLi = currentItem.closest('li');
        if (!parentLi) return;

        // Go up two levels to get the top-level menu item
        let grandParentLi = parentLi.parentElement.closest('li');
        if (!grandParentLi) grandParentLi = parentLi;

        // Remove focus class and hide submenu
        grandParentLi.classList.remove('focus');

        const submenu = grandParentLi.querySelector('ul[role="menu"]');
        // hide submenu
        if (submenu) {
          submenu.style.display = 'none';
        }

        // Collapse the trigger and focus the parent
        const trigger = grandParentLi.querySelector('[role="menuitem"]');
        if (trigger) {
          trigger.setAttribute('aria-expanded', 'false');
          trigger.focus();
        }
        break;

    }
  });
});
// -- Handling  key board tabbing - END -- //
export default enable;

